/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_ball': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<path pid="0" d="M13 4l4.5-2.665M13 4L8.5 1.335M13 4v3.5m-8.56 2.719L3.297 5.115m1.145 5.104L.515 13.675m3.926-3.456L7.769 11.3m-.059 8.98l-5.207-.488m5.207.488l2.074 4.802M7.71 20.28l2.057-2.831m8.523 2.831l-2.074 4.802m2.074-4.802l5.207-.488m-5.207.488l-2.057-2.831m5.326-7.231l3.926 3.456m-3.925-3.456l1.144-5.104m-1.145 5.104L18.232 11.3M13 7.444l5.282 3.838-2.018 6.21h-6.53l-2.018-6.21L13 7.446zM25.5 13c0 6.904-5.596 12.5-12.5 12.5S.5 19.904.5 13 6.096.5 13 .5 25.5 6.096 25.5 13z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_ball.js